import React from 'react'
import OfferList from './components/OfferList'
import SiteImagesSlider from './components/SiteImagesSlider'
import { Divider } from '@mui/material'
import Articles from './components/Articles'
import PopularProducts from './components/PopularProducts'
import Feedback from './components/Feedback'
import Inspiration from './components/Inspiration'
import RecentlyViewed from '@components/RecentlyViewed/RecentlyViewed'

const HOME_MAX_WIDTH = 1440

interface PageProps {}

const Page: React.FC<PageProps> = ({}) => {
  return (
    <div>
      <div className='mx-auto' style={{ maxWidth: HOME_MAX_WIDTH + 300 }}>
        <OfferList />
      </div>
      <Divider />
      <div className='mx-auto' style={{ maxWidth: HOME_MAX_WIDTH }}>
        <SiteImagesSlider />
        {/*<Collections />*/}
        <PopularProducts />
      </div>
      <div className='mx-auto' style={{ maxWidth: HOME_MAX_WIDTH }}>
        <Inspiration />
        {/*<SpecialFeatures />*/}
        <RecentlyViewed slidesPerView={8} align='center' />
        <Feedback />
        <Articles />
        {/*<NewProducts />*/}
      </div>
    </div>
  )
}

export default Page
